import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { fetch_one, fetch_all } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';
import { currentPracticeAtom } from '../../../../lib/practice';

import {
  Grid,
} from '@mui/material';

import {
  Button,
  Dt,
  Editor,
  Typography
} from '../../../../components/v2/styled';
import { SnackPdfGenned } from '../../../../components/v2/snacks/PdfGenned';

import { Advice } from '../../../../models/Advice';

// const { DateTime } = require("luxon");

type Props = {
  onClick: (b:boolean) => void;
  open: boolean;
  setOpen: (b:boolean) => void;
  advice: Advice;
  clonedAdvice: Advice;
  setAdvice: (d:Advice) => void;
  loading?: boolean;
  activeCompare?: Advice;
  userId?: number;
};

export const CoachEditAdviceTab5: FunctionComponent<Props> = ({activeCompare, userId, loading, open, setOpen, advice, clonedAdvice, setAdvice, onClick}) => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const [login, setLogin] = useAtom(loginAtom);
  const [currentPractice, setCurrentPractice] = useAtom(currentPracticeAtom);
  const {t, i18n} = useTranslation(['translations']);

  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);
  const [snackOpen, setSnackOpen] = useState<boolean>(false);

  // useEffect(() => {
  //   setFlickerEditor(true);
  //   setTimeout(() => {setFlickerEditor(false);}, 200);
  // }, []);











  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{custom_result: {success?: boolean;}}>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/objects/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setSnackOpen(true);
    },
  });
  

  return (<>
    <Grid item xs={12} sx={{position: 'relative'}}>
      <Typography html sx={{
        borderRadius: 1,
        border: '1px solid transparent',
        borderColor: theme.palette.warning.main,
        padding: 2,
        textAlign: 'center'
      }}>{t("new_advices.detail.warnings.advice_generate_pdf")}</Typography>
      <Button
        id="pdf"
        loading={mutationCustomAction.isPending}
        contained
        size='small'
        onClick={(e) => {
          let formData = new FormData();
          formData.append('object', 'advice');
          formData.append('class_action', 'custom_api_generate_pdf');
          formData.append('handler_id', (login?.id || "").toString());
          formData.append('fields[]', 'id');
          if (!!advice.id) formData.append('unsaved_reference[id]', advice.id.toString());
          if (!!advice.id) formData.append('id', advice.id.toString());
          // mainObject
          formData.append('unsaved_reference[user_id]', (userId || "").toString());
          formData.append('unsaved_reference[practice_id]', (currentPractice?.id || "").toString());
          formData.append('unsaved_reference[comment]', advice?.comment || '');
          formData.append('unsaved_reference[deals]', advice?.deals || '');
          formData.append('unsaved_reference[goals]', advice?.goals || '');
          formData.append('unsaved_reference[education]', advice?.education || '');
          formData.append('unsaved_reference[next_time]', advice?.next_time || '');
          formData.append('unsaved_reference[internal_comment]', advice?.internal_comment || '');
          formData.append('unsaved_reference[advice_date]', advice?.advice_date || '');
          formData.append('unsaved_reference[weight]', advice?.weight || '');
          formData.append('unsaved_reference[waist]', advice?.waist || '');
          formData.append('unsaved_reference[anamnese][breakfast]', advice?.anamnese?.breakfast || '');
          formData.append('unsaved_reference[anamnese][lunch]', advice?.anamnese?.lunch || '');
          formData.append('unsaved_reference[anamnese][diner]', advice?.anamnese?.diner || '');
          formData.append('unsaved_reference[anamnese][snack_1]', advice?.anamnese?.snack_1 || '');
          formData.append('unsaved_reference[anamnese][snack_2]', advice?.anamnese?.snack_2 || '');
          formData.append('unsaved_reference[anamnese][snack_3]', advice?.anamnese?.snack_3 || '');
          formData.append('unsaved_reference[anamnese][aversion]', advice?.anamnese?.aversion || '');
          formData.append('unsaved_reference[anamnese][preference]', advice?.anamnese?.preference || '');
          formData.append('unsaved_reference[anamnese][saturday]', advice?.anamnese?.saturday || '');
          formData.append('unsaved_reference[anamnese][sunday]', advice?.anamnese?.sunday || '');
          formData.append('unsaved_reference[anamnese][weekend_general]', advice?.anamnese?.weekend_general || '');
          formData.append('unsaved_reference[anamnese][pattern]', advice?.anamnese?.pattern || '');
          formData.append('unsaved_reference[anamnese][fluids]', advice?.anamnese?.fluids || '');
          formData.append('unsaved_reference[anamnese][extra_information]', advice?.anamnese?.extra_information || '');
          formData.append('unsaved_reference[anamnese][daily_dairy]', advice?.anamnese?.daily_dairy || '');
          formData.append('unsaved_reference[anamnese][daily_fats]', advice?.anamnese?.daily_fats || '');
          formData.append('unsaved_reference[anamnese][daily_fruits]', advice?.anamnese?.daily_fruits || '');
          formData.append('unsaved_reference[anamnese][daily_grains]', advice?.anamnese?.daily_grains || '');
          formData.append('unsaved_reference[anamnese][daily_meats]', advice?.anamnese?.daily_meats || '');
          formData.append('unsaved_reference[anamnese][daily_proteins]', advice?.anamnese?.daily_proteins || '');
          formData.append('unsaved_reference[anamnese][daily_salts]', advice?.anamnese?.daily_salts || '');
          formData.append('unsaved_reference[anamnese][daily_supplements]', advice?.anamnese?.daily_supplements || '');
          formData.append('unsaved_reference[anamnese][daily_veggies]', advice?.anamnese?.daily_veggies || '');
          formData.append('unsaved_reference[idx]', advice?.idx?.toString() || '');
          formData.append('unsaved_reference[episode]', advice?.epi?.toString() || '');
          formData.append('unsaved_reference[general_advice]', advice?.general_advice || '');

          if (advice.items) {
            advice.items.forEach(item => {
              formData.append(`unsaved_reference[items][]`, item);
            });
          }
          if (advice.items_private) {
            advice.items_private.forEach(item => {
              formData.append(`unsaved_reference[items_private][]`, item);
            });
          }
          if (!advice.attachments || advice.attachments.length < 1) {
            formData.append(`unsaved_reference[attachments][][id]`, '0');
          }
          if (advice.attachments) {
            advice.attachments.forEach(item => {
              formData.append(`unsaved_reference[attachments][][id]`, item.id?.toString() || '');
            });
          }
          
          mutationCustomAction.mutate({
            formData: formData
          });
        }}
        label={t("coach.general.actions.generate_pdf")}
        sx={{
          position: 'absolute',
          top: 0,
          right: 0
        }}
      />
    </Grid>

    {!!activeCompare && <Grid item xs={6}>
      <Typography variant="h4" sx={{textDecoration: 'underline'}}>{t("new_advices.detail.compare.title_current")}: {advice.identification} (<Dt o={advice.advice_date} />)</Typography>
    </Grid>}
    {!!activeCompare && <Grid item xs={6}>
      <Typography variant="h4" sx={{textDecoration: 'underline'}}>{t("new_advices.detail.compare.title_comparison")}: {activeCompare.identification} (<Dt d={activeCompare.advice_date} />)</Typography>
    </Grid>}

    <Grid item xs={!!activeCompare ? 6 : 12}>
      {!flickerEditor && <Editor
        advanced
        label={t("coach.models.advices.general_advice")}
        value={advice?.general_advice || ""}
        outside_world
        onChange={(e) => {
          setAdvice({
            ...advice,
            general_advice: e
          });
        }}
        height={250}
      />}
    </Grid>
    {!!activeCompare &&  <Grid item xs={6}>
      {!flickerEditor && <Editor
        advanced
        balloon
        disabled
        label={t("coach.models.advices.general_advice")}
        value={activeCompare?.general_advice || ""}
        onChange={(e) => {
          
        }}
        height={250}
      />}
    </Grid>}
    
    <SnackPdfGenned open={snackOpen} setOpen={setSnackOpen} />
  </>);
}
